import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';

import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import * as _moment from 'moment';

import { default as _rollupMoment, Moment } from 'moment';
import { BehaviorSubject, debounceTime, distinctUntilChanged, map, startWith } from 'rxjs';
import { UserActivityModel } from 'src/app/models/common/user-activity-model';
import { UserMasterApiService } from 'src/app/services/domain_code/user-master-api.service';

const moment = _rollupMoment || _moment;
export const MONTH = {
    parse: {
        dateInput: 'MM/YYYY',
    },
    display: {
        dateInput: 'MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    selector: 'login-activity',
    templateUrl: './login-activity.component.html',
    styleUrls: ['./login-activity.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },

        { provide: MAT_DATE_FORMATS, useValue: MONTH },
    ],
})
export class LoginActivityComponent implements OnInit {

    pageSizeOptions: number[] = [5, 10, 25, 100];
    pageLength = 0;
    pageSize = 10;
    pageIndex = 0;
    searchTerm = '';
    searchText = new BehaviorSubject<string>('');
    user_activity_list: MatTableDataSource<UserActivityModel>;

    displayedColumns: string[] = ['device_details', 'browser', 'location_of_access', 'ip_address'];
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;
    date = new FormControl(moment());

    setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {
        const ctrlValue = this.date.value!;
        ctrlValue.month(normalizedMonthAndYear.month());
        ctrlValue.year(normalizedMonthAndYear.year());
        this.date.setValue(ctrlValue);
        datepicker.close();
    }

    constructor(private userActivityService: UserMasterApiService) {
    }

    ngOnInit() {
        this.refreshUserActivityList();

        this.searchText.pipe(
            startWith(''),
            distinctUntilChanged(),
            debounceTime(1000),
            map((searchText) => {
                this.refreshUserActivityList(this.pageSize, this.pageIndex, searchText)
            })
        ).subscribe();
    }

    applyFilter(event) {
        this.pageIndex = 0;
        this.searchText.next(event);
    }

    refreshUserActivityList(pageSize = null, pageIndex = null, searchTerm = '', ordering = '') {
        pageSize = pageSize || this.pageSize;
        pageIndex = pageIndex || this.pageIndex;
        if (searchTerm != null) {
            this.searchTerm = searchTerm;
        }
        this.userActivityService.getUserActivity(pageSize, pageIndex + 1, this.searchTerm, ordering).subscribe({
            next: response => {
                this.user_activity_list = new MatTableDataSource(response.results);
                this.pageLength = response.count;
            },
            error: error => {
                console.log("User activity", error);
                return error;
            }
        });
    }

    announceSortChange(sortState: Sort) {
        switch (sortState.direction) {
            case 'asc':
                this.refreshUserActivityList(this.pageSize, this.pageIndex, this.searchTerm, sortState.active);
                break;

            case 'desc':
                this.refreshUserActivityList(this.pageSize, this.pageIndex, this.searchTerm, `-${sortState.active}`);
                break;

            default:
                this.refreshUserActivityList(this.pageSize, this.pageIndex, this.searchTerm);
        }
    }

    pageChanged(event: PageEvent) {
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.refreshUserActivityList();
    }
}
